<i
  class="fa-star default-indicator"
  [ngClass]="isDefault ? 'fas text-success' : 'far'"
  (click)="toggleDefault()"
  [matTooltip]="getTooltipText"
  [matTooltipPosition]="tooltipPosition"
></i>
